export const formControlNames = {
    suppliers: 'suppliers',
    contactAddress: 'contactAddress',
};
